import React from 'react';

import { Placeholder } from 'types/step';
import * as Text from 'theme/components/Text.style';
import * as Styled from 'form/styles/FormEditView.style';

import BooleanField from './BooleanField';
import DateField from './DateField';
import NumberField from './NumberField';
import MultidateField from './MultidateField';
import DateTextListField from './DateTextListField';
import ChoiceField from './ChoiceField';
import StringField from './StringField';

interface FormFieldRendererProps {
  placeholder: Placeholder & { slug: string };
}

function isMultiline(placeholder: Placeholder): boolean {
  return placeholder.format === 'multiline';
}

export default function FormFieldRenderer({
  placeholder,
}: FormFieldRendererProps): JSX.Element {
  const renderField = () => {
    switch (placeholder.type) {
      case 'boolean':
        return <BooleanField slug={placeholder.slug} />;
      case 'date':
        return <DateField slug={placeholder.slug} />;
      case 'multidate':
        return <MultidateField slug={placeholder.slug} />;
      case 'dateTextList':
        return <DateTextListField slug={placeholder.slug} />;
      case 'choice':
        return (
          <ChoiceField
            slug={placeholder.slug}
            label={placeholder.displayName}
            options={placeholder.options || []}
          />
        );
      case 'number':
      case 'float':
        return (
          <NumberField slug={placeholder.slug} inputType={placeholder.type} />
        );
      case 'string':
      default:
        return (
          <StringField
            slug={placeholder.slug}
            multiline={isMultiline(placeholder)}
          />
        );
    }
  };

  return (
    <Styled.FieldGroup>
      <Text.P2Semibold>{placeholder.displayName}</Text.P2Semibold>
      {renderField()}
    </Styled.FieldGroup>
  );
}
